import logo from "../../images/UA_Logo_WHT_RGB.png";
import isAuthenticated from "../../components/Utils/isAuthenticated";
import GiveRoleForm from "../Access/GiveRoleForm";
import MCExams from "../../images/mc-exams.png";
import SPOTGraphic from "../../images/spot-graphic.png";
import MidtermGraphic from "../../images/tsqs-midterm.png";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import { NAV_GROUPS, canSeeNavGroup } from "../../config/routes";

const serviceLinks = {
	"test-scoring":
		"https://www.ualberta.ca/en/information-services-and-technology/services/test-scoring-questionnaire-services/multiple-choice-scoring.html",
	spot: "https://www.ualberta.ca/en/information-services-and-technology/services/test-scoring-questionnaire-services/student-perspectives-of-teaching.html",
	midterm:
		"https://www.ualberta.ca/en/information-services-and-technology/services/test-scoring-questionnaire-services/midterm-instruction-feedback.html",
	surveys:
		"https://www.ualberta.ca/en/information-services-and-technology/services/test-scoring-questionnaire-services/survey-tools.html",
};


export default function HomeLanding() {
	let auth = isAuthenticated();
	/* const token = auth.token; */
	const ccid = auth.ccid;
	const access = auth.access;

	// Service card component with clickable title only
	const ServiceCard = ({
		internalLink,
		internalLinkText,
		externalLink,
		imgSrc,
		imgAlt,
		title,
		description,
		canAccessInternal,
	}) => {
		return (
			<div className="rounded-lg border border-gray-200 bg-white shadow-sm transition-shadow overflow-hidden flex flex-col">
				<div className="aspect-video w-full overflow-hidden bg-gray-50">
					<img alt={imgAlt} src={imgSrc} className="w-full h-full object-cover" />
				</div>
				<div className="p-5 flex-1 flex flex-col justify-between">
					<div>
						<div className="text-lg font-semibold text-primary mb-2 group  inline-flex items-center gap-1.5 w-fit">
							{title}
						</div>
						<p className="text-sm text-gray-600 leading-relaxed">{description}</p>
					</div>
					<div className="flex items-center justify-between">
						<Button
							component={RouterLink}
							to={externalLink}
							variant="standard"
							target="_blank"
							rel="noopener noreferrer"
							sx={{
								paddingLeft: 0,
							}}
							className="text-sm text-gray-600 leading-relaxed hover:text-green-800 hover:underline transition-colors group inline-flex items-center gap-1.5  mt-4"
						>
							UAlberta Webpage
							<LaunchIcon fontSize="xsmall" color="inherit" />
						</Button>
						{internalLink && internalLink === "/test-scoring" && !canAccessInternal && (
							<GiveRoleForm
								buttonTitle="Request Access"
								buttonVariant="outlined"
								buttonWidth="140px"
							/>
						)}
						{internalLink && canAccessInternal && (
							<Button
								component={RouterLink}
								to={internalLink}
								variant="contained"
								className="mt-4 w-fit flex items-center gap-2"
							>
								{internalLinkText}
							</Button>
						)}
					</div>
				</div>
			</div>
		);
	};

	if (ccid && !access) {
		return (
			<div className="h-full max-h-[calc(100%-160px)]">
				<div className="h-[510px] bg-gray-100 flex flex-col justify-center items-center gap-5 px-8">
					<p className="text-center text-xl text-gray-800">
						Oops! Something went wrong and it seems you don't have access to this application.
					</p>
					<p className="text-center text-xl text-gray-800">
						Please contact us at tsqsweb@ualberta.ca for assistance.
					</p>
					<GiveRoleForm
						buttonTitle="Trying to Submit an Exam Grading Request?"
						buttonVariant="outlined"
						buttonWidth="350px"
					/>
				</div>
			</div>
		);
	} else {
		return (
			<div className="flex flex-col min-h-screen bg-digitalWhite">
				{/* TSQS Services Section */}
				<div className="bg-digitalWhite py-12 md:py-12 px-6 md:px-14">
					<div className="  mx-auto">
						<h1 className="text-4xl md:text-6xl font-regular mb-6 text-gray-900 leading-relaxed ">
							Test Scoring & Questionnaire Services (TSQS)
						</h1>
						<p className="text-lg md:text-xl font-light mb-10 text-gray-700 leading-relaxed w-full ">
							Test Scoring & Questionnaire Services (TSQS) supports test scoring, survey data
							collection, and general data-collection activities for the University of Alberta. TSQS
							is also responsible for the generation and processing of the Student Perspectives of
							Teaching (SPOT) questionnaires and reports. Explore our services below or contact us
							for more information.
						</p>
						<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
							<ServiceCard
								externalLink={serviceLinks["spot"]}
								internalLink={"/reporting"}
								internalLinkText={"Go to Reporting"}
								canAccessInternal={canSeeNavGroup("reporting", access)}
								imgSrc={SPOTGraphic}
								imgAlt="SPOT Surveys"
								title="SPOT Surveys"
								description="End of term course feedback using the Student Perspectives of Teaching survey instrument."
							/>
							<ServiceCard
								externalLink={serviceLinks["test-scoring"]}
								internalLink={"/test-scoring"}
								internalLinkText={"Submit Request"}
								canAccessInternal={canSeeNavGroup("exam", access)}
								imgSrc={MCExams}
								imgAlt="Multiple Choice Exams"
								title="Test Scoring"
								description="Scoring and reporting for multiple choice exams and written Assign2 exams."
							/>
							<ServiceCard
								externalLink={serviceLinks["midterm"]}
								imgSrc={MidtermGraphic}
								imgAlt="Mid-term Course and Instruction Feedback"
								title="Mid-term Course and Instruction Feedback Questionnaires"
								description="An optional tool for instructors to gather feedback in the middle of the semester."
							/>
						</div>
					</div>
				</div>
				{/* Contact & Business Hours Section */}
				<div className="bg-digitalWhite py-12 md:py-16 px-6 md:px-20">
					<div className="  mx-auto">
						<div className="grid md:grid-cols-2 gap-10 md:gap-16">
							<div className="flex flex-col gap-5">
								<h2 className="text-4xl md:text-5xl font-regular mb-2 text-gray-900">Contact Us</h2>
								<p className="text-base font-light text-gray-700 leading-relaxed">
									Don't hesitate to reach out with any questions or concerns related to our list of
									services. Check our FAQ page below for common questions and instructions for self
									serve options.
								</p>
								<p className="text-base font-light text-gray-700 leading-relaxed">
									Support staff can be reached by emailing{" "}
									<a
										href="mailto:test.scoring@ualberta.ca"
										target="_blank"
										rel="noreferrer"
										className="text-primary underline hover:text-green-800 transition-colors font-normal"
									>
										test.scoring@ualberta.ca
									</a>{" "}
									or calling <span className="font-medium text-gray-900">780.492.2741</span>. The
									TSQS office is located at{" "}
									<a
										href="https://www.ualberta.ca/maps.html?l=53.526142,-113.529437&z=17&campus=north_campus&b=gsb"
										target="_blank"
										rel="noreferrer"
										className="text-primary underline hover:text-green-800 transition-colors font-normal"
									>
										240 General Services Building
									</a>
									.
								</p>
								<a
									href="https://www.ualberta.ca/information-services-and-technology/services/test-scoring-questionnaire-services/student-perspectives-of-teaching.html"
									target="_blank"
									rel="noreferrer"
									className="text-base font-light text-primary underline hover:text-green-800 transition-colors inline-block"
								>
									Frequently Asked Questions →
								</a>
							</div>

							<div className="flex flex-col">
								<h2 className="text-4xl md:text-5xl font-regular mb-6 text-gray-900">
									Office Hours
								</h2>
								<div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
									<div className="bg-white rounded-lg p-5 border border-gray-200 shadow-sm">
										<h3 className="text-base font-semibold text-primary mb-3">Fall/Winter</h3>
										<p className="text-sm text-gray-700 leading-relaxed">Monday to Friday</p>
										<p className="text-sm text-gray-700 leading-relaxed">8:30 a.m. - 12:00 p.m.</p>
										<p className="text-sm text-gray-500 italic leading-relaxed">
											Closed 12:00 p.m. - 1:00 p.m.
										</p>
										<p className="text-sm text-gray-700 leading-relaxed">1:00 p.m. - 4:30 p.m.</p>
									</div>
									<div className="bg-white rounded-lg p-5 border border-gray-200 shadow-sm">
										<h3 className="text-base font-semibold text-primary mb-3">Spring/Summer</h3>
										<p className="text-sm text-gray-700 leading-relaxed">Monday to Friday</p>
										<p className="text-sm text-gray-700 leading-relaxed">8:00 a.m. - 12:00 p.m.</p>
										<p className="text-sm text-gray-500 italic leading-relaxed">
											Closed 12:00 p.m. - 1:00 p.m.
										</p>
										<p className="text-sm text-gray-700 leading-relaxed">1:00 p.m. - 4:00 p.m.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Territorial Acknowledgement Section */}
				<div className="bg-primary text-white mt-12 md:mt-16 py-12 md:py-16 px-6 md:px-20">
					<div className="  mx-auto">
						<h2 className="text-4xl md:text-5xl text-[#F2CD00] font-light mb-6">
							Territorial Acknowledgement
						</h2>
						<p className="text-lg md:text-xl font-light leading-relaxed max-w-5xl">
							The University of Alberta, its buildings, labs, and research stations are primarily
							located on the traditional territory of Cree, Blackfoot, Métis, Nakota Sioux,
							Iroquois, Dene, and Ojibway/Saulteaux/Anishinaabe nations; lands that are now known as
							part of Treaties 6, 7, and 8 and homeland of the Métis. The University of Alberta
							respects the sovereignty, lands, histories, languages, knowledge systems, and cultures
							of First Nations, Métis and Inuit nations.
						</p>
						<div className="h-[3px] bg-white my-12 md:my-16"></div>
						<div className="flex justify-center">
							<img
								alt="University of Alberta Logo"
								src={logo}
								loading="eager"
								className="w-full max-w-[20rem] h-16 object-contain"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
